/**
 * DescriptionBottomMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description bottom mask.
 */
const DescriptionBottomMask = styled.div`
  background: linear-gradient(
    183deg,
    rgba(0, 0, 0, 0) 33.13%,
    #000 52.68%,
    #000 92.92%
  );
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default DescriptionBottomMask;
